export default function Showcaseblock() {
  Alpine.data("showcaseblock", (total) => ({
    current: 0,
    items: Array.from({ length: total }, (_, i) => i),

    nav(index) {
      this.current = index;
    },
  }));
}
